import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LayoutComponent } from 'app/layout/layout.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        FormsModule,
        SharedModule
    ],
    exports     : [
        LayoutComponent
    ]
})
export class LayoutModule
{
}
